var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"my-simple-layout"},[_c('el-header',{staticClass:"header"},[_c('my-simple-header')],1),_c('el-main',[_vm._t("default")],2),_c('el-footer',{staticClass:"footer center-flex"},[_c('my-beian')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }